/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "courses",
            "endpoint": "https://voju93k7e9.execute-api.ap-southeast-1.amazonaws.com/bootcamp",
            "region": "ap-southeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-1:6750a5a7-b80d-47fe-b455-664e350fa8dd",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_7YuqAgQ7H",
    "aws_user_pools_web_client_id": "68ghmbmph6sduliifo7jk12be3",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-southeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AccessCode-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "Categories-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "Cert-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "Contributor-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "CourseCode-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "CourseOpportunity-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "FAQs-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "Lectures-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "UIConfig-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "UserCourse-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "UserLecture-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "UserProgress-bootcamp",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "courses-bootcamp",
            "region": "ap-southeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "lecture-resource203319-bootcamp",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
